import MoleculeTextareaField from '@s-ui/react-molecule-textarea-field'

import {ID_COMMENT_FORM_DEALER_RATING} from './../config.js'
import {QuestionRenderer} from './QuestionRenderer.js'

export class FinalQuestionRenderer extends QuestionRenderer {
  render({showError, comment, maxChars, placeholder, textCharacters, errorText, onChange}) {
    return (
      <div className="mt-FormDealerRating-stepTextArea">
        <MoleculeTextareaField
          autoHideHelpText={showError}
          id={ID_COMMENT_FORM_DEALER_RATING}
          maxChars={maxChars}
          value={comment}
          onChange={onChange}
          placeholder={placeholder}
          tabIndex="0"
          resize="vertical"
          textCharacters={textCharacters}
          errorText={showError && errorText}
        />
      </div>
    )
  }
}
